import React, { useCallback, useRef } from "react";
import EditableWrapper, { InputType } from "@/components/ui/editable-wrapper";
import { SyncedTipTapEditor } from "../SyncedTipTapEditor";
import { FeaturePRD, PRD_CONSTANTS } from "../constants";

interface PRDEditorProps {
  featurePrd?: FeaturePRD;
  onEditPrd: (field: string, value: string, saveToDb?: boolean) => void;
}

const PRDEditor: React.FC<PRDEditorProps> = ({ featurePrd, onEditPrd }) => {
  const descriptionRef = useRef<{ focus: () => void }>(null);

  const onEditTitle = useCallback(
    async (newValue: string) => {
      onEditPrd("title", newValue, true);
    },
    [onEditPrd],
  );

  const onTitleEnter = useCallback(() => {
    descriptionRef.current?.focus();
  }, []);

  return (
    <div className="p-0 space-y-6">
      <div className="flex px-6 py-4 flex-col justify-between items-start">
        <EditableWrapper
          value={featurePrd?.title || PRD_CONSTANTS.DEFAULT_FEATURE_TITLE}
          onEdit={onEditTitle}
          onEnter={onTitleEnter}
          linearMode={true}
          type={InputType.TEXTAREA}
          maxLength={PRD_CONSTANTS.MAX_TITLE_LENGTH}
          realTimeUpdate={true}
        >
          <div className="text-xl font-semibold text-text-primary">
            {featurePrd?.title || PRD_CONSTANTS.DEFAULT_FEATURE_TITLE}
          </div>
        </EditableWrapper>
      </div>

      <div className="pt-0 pb-4 px-6 m-0!">
        <SyncedTipTapEditor
          ref={descriptionRef}
          classnames="min-h-12! py-0 px-0 text-sm! leading-5! w-full max-w-full wrap-break-word"
          valueInSupabase={featurePrd?.prd || ""}
          onUpdateValueInSupabase={(newValue) =>
            onEditPrd("prd", newValue, true)
          }
          placeholder={PRD_CONSTANTS.DEFAULT_PRD_PLACEHOLDER}
        />
      </div>
    </div>
  );
};

export default PRDEditor;
